import { ReactNode } from "react";
import { Navigate } from "react-router";
import { useIsAccounting } from "./useIsAccounting";

// Gate de las rutas de contabilidad (clon de RequireAdmin): sin acceso →
// redirect al panel. El backend aplica la policy "Accounting" de verdad.
// Mientras /api/me está en vuelo, placeholder — no redirigir en falso.
export default function RequireAccounting({ children }: { children: ReactNode }) {
  const { isAccounting, isLoading } = useIsAccounting();
  if (isLoading) return <div className="p-6 text-sm text-slate-600">Cargando…</div>;
  if (!isAccounting) return <Navigate to="/" replace />;
  return <>{children}</>;
}
